import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BehaviorSubject, catchError, forkJoin, map, Subject, Subscription} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';

// import * as XLSX from 'xlsx';
import {DOCUMENT} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
import {FormBuilder, FormControl} from '@angular/forms';
import {BackendListModel} from 'src/app/models/common/list.model';
import {DomainCodeApiService} from 'src/app/services/domain_code/domain-code-api.service';
import {DomainCode} from 'src/app/models/common/model';
import {ContainerMasterApiService} from 'src/app/services/domain_code/container-master-api.service';
import {ContainerSizeType} from 'src/app/models/container_master_model/sizeType';
import {ContainerModel, Lifecycle} from 'src/app/models/container_master_model/container-model';
import {LeaseAgreementModel} from 'src/app/models/container_master_model/lease';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentModel} from 'src/app/models/document';
import {ApiRoutes} from 'src/app/services/apiroutes';
import {CustomStepper} from './cdk-custom-stepper';
import {WarningBoxComponent} from '../../dialog-box/warning-box/warning-box.component';
import {ContainerGradeModel} from 'src/app/models/container_master_model/container-grade-model';
import {DepotMasterTab1} from 'src/app/models/Depot_Master_Model/depot-master-tab1';
import {DepotMasterApiService} from 'src/app/services/domain_code/depot-master-api.service';
import {LocationApiService} from 'src/app/services/domain_code/location-api.service';
import {RequestorDialogComponent} from '../../dialog-box/requestor-dialog/requestor-dialog.component';

@Component({
    selector: 'app-custom-stepper',
    templateUrl: './custom-stepper.component.html',
    styleUrls: ['./custom-stepper.component.scss', './review-data.scss'],
})


export class CustomStepperComponent implements OnInit {
    @Input()
    containerObj: ContainerModel;

    @Input()
    isEditable: boolean = true; // For switching between editable fields and labels

    @Input()
    errorObj: any = {};

    @Input()
    loaderSubject = new Subject<boolean>()

    loader: boolean = true;

    @Output("back") back: EventEmitter<any> = new EventEmitter();

    @Output("addNew") addNew: EventEmitter<any> = new EventEmitter();

    @Output()
    closeForm = new EventEmitter<ContainerModel>();

    @Output()
    isEditableChange = new EventEmitter<boolean>();

    @Output()
    refreshContainer = new EventEmitter<string>();

    base_url = ApiRoutes.Location;
    country_url = ApiRoutes.Geo;
    container_url = ApiRoutes.ContainerMaster;
    company_url = ApiRoutes.Company;
    containerGrade: boolean = false;
    containerGradeObj: ContainerGradeModel;
    clickedContainerObj; // For Dialog Box when selecting container
    Canvas: string = "Canvas";
    open: string = "sidepanel";
    depotData = new Subject<string>();
    lifeCycleCount: number = null

    bookingDetails: any;

    // depotObject: DepotMasterTab1;
    defaultDepot: DepotMasterTab1 = {
        id: null,
        name: null,
        location_type: '',
        depot_owner_type: null,
        local_name: null,
        address: null,
        agreement_valid_date: null,
        location_billing_type: null,
        location_email: null,
        location_contact_no: null,
        working_hrs_from: null,
        working_hrs_to: null,
        week_offs: null,
        is_edi_available: true,
        edi_code: null,
        remarks: null,
        country: null,
        state: null,
        depot_week_offs: '',
        ports: [],
        connectivities: [],
        free_storage_days_upto_teus: null,

        is_active: true
        // approachable_via:[]
    }
    selectedDepot = { ...this.defaultDepot };

    @ViewChild('badStepper') stepper: CustomStepper;

    isLeaseEditable: boolean = false;
    isNotEditable: boolean = true;

    sizeTypeListFromPurchaseOrder = []
    containerLifecycleStatus: string;
    containerActivityDate;
    containerPurposeLabel: string = "Container Purpose*";
    containerEYLabel: string = "First EY at*";
    containerEYDateLabel: string = "First EY on*";
    EYTooltip: string = "Select the depot where first time the container was moved empty.";
    EYDateTooltip: string = "Select the date when empty container was moved into depot.";
    portTooltip: string = "Select the port against which the stock will reflect.";

    editableToggle() {
        if (this.isEditable) {
            this.postContainer();
        } else {
            if (this.containerObj.lifecycle != null) {
                if (this.containerObj.lifecycle.status_type == 0) {
                    this.statusWarning('re-enter', `The container's last status was: ${this.containerObj.lifecycle.name}`,
                        "However, you can re-enter it in system with latest details.", "Go back", "Edit details");
                }
                if (this.containerObj.lifecycle.status_type == -1) {
                    this.statusWarning('no-entry', `Sorry the container's last status was: ${this.containerObj.lifecycle.name}`,
                        "So you cannot edit or re-enter it in system.", "Go back", null);
                }
            }
            if (!this.isEditable) {
                // default photo selected on edit mode
                if (this.containerObj.photos != null) {
                    for (let i = 0; i < this.containerObj.photos.length; i++) {
                        if (this.containerObj.default_photo != null) {
                            if (this.containerObj.default_photo.id == this.containerObj.photos[i].id) {
                                this.containerObj.default_photo = this.containerObj.photos[i];
                            }
                        }
                    }
                }
                this.isEditable = true;
            }
        }
    }

    statusWarning(type, label: string, desc, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: this, description: desc, label1: action1, label2: action2 }
        })
        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                switch (type) {
                    case 're-enter':
                        this.isEditable = true;
                        break;
                    case 'no-entry':
                        break;
                }
            } else {
                this.router.navigateByUrl(`/dashboards/master-dashboard`);
            }
        });
    }

    // proceedAction(parent) {
    //     parent.router.navigate([], {
    //         queryParams: {
    //             'id': null,
    //         },
    //         queryParamsHandling: 'merge'
    //     });
    //     setTimeout(() => {
    //         window.location.reload();
    //     }, 500);

    // }

    // goBackAction(parent) {
    //     setTimeout(() => {
    //         parent.router.navigateByUrl(`/dashboards/master-dashboard`);
    //     }, 1000);
    // }

    selectCDKIndex(index) {
        this.stepper.selectStepByIndex(index);
    }

    // Get stepper index to jump to when error occurs
    jumpToStepOnError(errorObject) {
        let keysInErrorObj = Object.keys(errorObject);

        let stepValue = keysInErrorObj.map(key => {
            return this.indexObject[key];
        }).reduce((item, k) => {
            return item;
        })

        return stepValue;
    }

    defaultLeaseObject: LeaseAgreementModel = {
        id: null,
        lease_type: null,
        agreement_number: null,
        agreement_starts_from: null,
        agreement_ends_on: null,
        lessor_company_name: null,
        lessor_contact_person_name: null,
        lessor_contact_person_email: null,
        lessor_contact_person_phone: null,
        request_number: null,
    }

    defaultLifeCycleObject: Lifecycle = {
        id: null,
        updated_at: null,
        created_at: null,
        is_active: null,
        name: null,
        status_type: null,
        color: null,
        dev_code: null,
        created_by: null,
        updated_by: null,
    }


    // photos_array = this.formBuilder.array([
    // this.documents
    // ]
    // )

    // documents_array = this.formBuilder.array([]
    // [this.documents]
    // )


    checked: boolean = false;
    counter: number = 0;
    counter1: number = 0;
    chng: number = 0;
    chng2: number = 0;
    chng3: number = 0;
    resetVar: boolean = false;
    hr: boolean = false;
    setAction2: boolean;
    currentDate = new Date(); // Variable to get current date
    // name!: string;
    title = 'dropzone';
    searchCtrl = new FormControl('');
    labelPosition: 'before' | 'after' = 'after';
    uploadedImage: boolean = false;

    public files: File[] = []; //linked with drag n drop
    public pics: File[] = []; // linked with upload default pic

    visibility = {
        card1: true,
        card2: true,
        card3: true,
        card4: true,
        card5: true,
        card6: true,
        card7: true,
    }

    clicked() {
        if (this.chng === 0) {
            this.counter = this.counter + 9;
            this.chng = +1;

        }
    }

    clicked1() {
        if (this.chng3 === 0) {
            this.counter = this.counter + 10;
            this.chng3 = +1;

        }
    }

    showUploadInfo() {
        //show the information text for choosing the default image which are uploaded while added.
        this.uploadedImage = true;
    }

    deleteUploadImg(selectedPic: any) {
        let noDefaultList = this.containerObj.photos.filter((item) => {
            if (item.id != selectedPic.id)
                return item;
        })

        if (this.containerObj.default_photo != null) {
            if (this.containerObj.default_photo.id === selectedPic.id) {
                this.containerObj.default_photo = null;
            }
        }

        this.containerObj.photos = noDefaultList
        this.containerPhotos = noDefaultList
    }

    containerPhotos: DocumentModel[];

    sortContainerObjPhotos(selectedPic: any) {
        let temp
        let noDefaultList = this.containerObj.photos.filter((item) => {
            if (item.id != selectedPic.id)
                return item
            else
                temp = item
        })
        noDefaultList.unshift(temp)
        this.containerPhotos = noDefaultList;
        this.containerObj.default_photo = temp;
        this.projectPhoto = this.containerObj.default_photo.document_file;
    }

    changed(event: any) {
        var val = event.target.value;
        var input = event.target.id;
        for (let i = 1; i < 10; i++) {
            if (input === "input" + i) {
                console.log(input)
                if (val != "") {
                    this.counter = this.counter + 8;
                }
                if (val === "") {
                    this.counter = this.counter - 8;
                }
                ;
            }
        }
    }

    changed1(event: any) {
        var val = event.target.value;
        var input = event.target.id;
        for (let i = 10; i < 23; i++) {
            if (input === "input" + i) {
                console.log(input)
                if (val != "") {
                    this.counter1 = this.counter1 + 9;

                }
                if (val === "") {
                    this.counter1 = this.counter1 - 9;

                }
                ;
            }
        }
    }

    export(): void {

        /* generate worksheet */
        // const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data1);

        // /* generate workbook and add the worksheet */
        // const wb: XLSX.WorkBook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // /* save to file */
        // XLSX.writeFile(wb, this.fileName1);
    }


    data1: AOA = [[1, 2], [3, 4]];
    fileName1: string = 'dataFormat.xlsx';
    @Input()
    requiredFileType: string | undefined;

    fileName = '';
    uploadProgress!: number;
    uploadSub!: Subscription;

    myControl = new FormControl<string>('');

    constructor(
        private route: ActivatedRoute,
        private _snackBar: MatSnackBar,
        @Inject(DOCUMENT) private document: Document,
        public dialog: MatDialog,
        private domainService: DomainCodeApiService,
        public containerMasterService: ContainerMasterApiService,
        private depotMasterService: DepotMasterApiService,
        private formBuilder: FormBuilder,
        private router: Router,
        private locationService: LocationApiService
    ) {

    }

    onFileChange(pFileList: File[]) {
        this.files = Object.keys(pFileList).map((key: any) => pFileList[key]);

        this.hr = true;
        for (let i = 0; i++; i + 1) {
            this.files[i].size
        }
        this._snackBar.open("Successfully upload!", 'Close', {
            duration: 2000,
        });
    }

    onFileChange1(event: any) {
        var pFileList: File[] = event.target.files;
        this.files = Object.keys(pFileList).map((key: any) => pFileList[key]);

        this.hr = true;
        this._snackBar.open("Successfully upload!", 'Close', {
            duration: 2000,
        });
    }

    onFilechange(uFileList: File[]) {
        this.files = Object.keys(uFileList).map((key: any) => uFileList[key]);
        this._snackBar.open("Successfully upload!", 'Close', {
            duration: 2000,
        });
    }

    // onFileChange2(event: any) {
    //   var uFileList: File[] = event.target.pics;
    //   this.pics = Object.keys(uFileList).map((key: any) => uFileList[key]);
    //   this._snackBar.open("Successfully upload!", 'Close', {
    //     duration: 2000,
    //   });
    // }

    deleteFile(f: any) {
        this.files = this.files.filter(function (w) {
            return w.name != f.name
        });
        this._snackBar.open("Successfully delete!", 'Close', {
            duration: 2000,
        });
    }

    deleteFromArray(index: any) {

        this.files.splice(index, 1);
    }

    cancelUpload() {
        this.uploadSub.unsubscribe();
        this.reset();
    }

    reset() {
        this.uploadProgress = 0;
        this.uploadSub.unsubscribe();
    }

    isShown!: boolean;
    single!: boolean;
    bulk!: boolean;
    showProcurement!: boolean;
    showLease!: boolean;
    showPC!: boolean;
    showBulk!: boolean;
    showDoc!: boolean;
    showCmplt!: boolean;
    showReview!: boolean;
    pic!: boolean;


    containerSizeType: ContainerSizeType;

    defaultObj: ContainerModel = {
        id: null,
        photos: [],
        documents: [],
        container_number: null,
        procured_from: null,
        vendor_name: null,
        tare_weight_kg: null,
        capacity_kg: null,
        csc_plate_number: null,
        csc_expiry_date: null,
        csc_remark: null,
        manufacture_date: null,
        maximum_gross_weight_kg: null,
        allowable_stacking_weight_kg: null,
        racking_test_load_value_kg: null,
        next_examination_date: null,
        remarks: null,
        acep: null,
        manufactured_by: null,
        default_photo: null,
        document_remarks: null,
        purchase_price: 0,
        purchase_price_currency: 'USD',
        device_name: null,
        device_id: null,
        first_ey_date: null,
        container_size: null,
        container_type: null,
        ownership: null,
        stock_owner: null,
        current_location: null,
        condition: null,
        purpose: null,
        first_ey_depot: null,
        current_depot: null,
        lease_agreement: { ...this.defaultLeaseObject },
        purchase_order: null,
        is_damaged: false,
        is_drv_declared: false,
        deleted_date_time: null,
        container_size_type: null,
        insert_mode: null,
        created_at: null,
        last_activity_date: null,
        updated_at: null,
        created_by: null,
        updated_by: null,
        lifecycle: { ...this.defaultLifeCycleObject },
        latest_new_container_lifecycle: null,
        invoice_date: null,
        invoice_number: null,
        assessment_value: null,
        assessment_value_currency: 'USD',
        domesticated_at: null,
        cha_agency_name: null,
        custom_duty_charge: null,
        custom_duty_charge_currency: 'USD',
        domestication_remarks: null
    }

    indexObject: any = {
        ownership: 0,
        insert_mode: 0,
        purchase_order: 0,
        vendor_name: 0,
        purchase_price: 0,
        purchase_price_currency: 0,
        procured_from: 0,
        lease: 0,
        container_number: 0,
        container_size_type: 0,
        container_size: 0,
        container_type: 0,
        condition: 0,
        purpose: 0,
        stock_owner: 0,
        device_name: 0,
        device_id: 0,

        maximum_gross_weight_kg: 1,
        tare_weight_kg: 1,
        capacity_kg: 1,
        allowable_stacking_weight_kg: 1,
        racking_test_load_value_kg: 1,
        csc_plate_number: 1,
        next_examination_date: 1,
        acep: 1,
        csc_remark: 1,
        csc_expiry_date: 1,
        manufacture_date: 1,
        manufactured_by: 1,
        first_ey_depot: 1,
        first_ey_date: 1,
        current_location: 1,

        remarks: 2,
        photos: 2,
        default_photo: 2,
        documents: 2,
        document_remarks: 2,
    }

    ngOnInit(): void {

        this.resetComponent();
        console.log("containerObj", this.containerObj)

        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.getContainerInfoById(params['id']);

                this.getContainerBookingDetails(params['id']);
                this.isEditable = false;
                this.isNotEditable = false;
            }
        });

        forkJoin([
            this.getContainerGroup(), // Container Ownership
            this.getContainerCondition(), // Container Condition
            this.getContainerPurpose(), // Container Purpose
            // this.getAllSizeTypes(), // For getting Container Size and Type
            this.getProcurementPortal(), // Portal, container procured from
            // this.getDocType(), // Document Type
            // this.getCurrencyType(), // Currency
            // this.getLeaseType(), // Lease type
            // this.getDepotName(), // Depot Location
            // this.getDevice(), // Device name
            // this.getPurchaseNumber(), // Purchase details
            // this.getLeaseData(), // Lease Details
        ]).subscribe(() => {
            // this.route.queryParams.subscribe(params => {
            //   if ('id' in params) {
            //     this.loader = false
            //     this.getContainerInfoById(params['id']);
            //     this.isEditable = false;
            //     this.isNotEditable = false;
            //   }
            // });
            setTimeout(() => {
                this.loader = false;
            }, 800);
        });

        this.loaderSubject.subscribe(item => {
            if (item == false) {
                this.resetComponent();
                this.loader = item;
            }
        })
    }

    resetComponent() {
        this.containerObj = { ...this.defaultObj };

        this.isShown = false; //hidden every time subscribe detects change
        this.bulk = false;
        this.showPC = true;
        this.showBulk = false;
        this.showDoc = true;
        this.showCmplt = false;
        this.showReview = false;
        this.single = false;
        this.pic = false;
        this.isEditable = true;
        this.isLeaseEditable = false;
        this.isNotEditable = true;
        this.counter = 0;

        this.containerPurposeLabel = "Container Purpose*";
        this.containerEYLabel = "First EY at*";
        this.containerEYDateLabel = "First EY on*";
        this.EYTooltip = "Select the depot where first time the container was moved empty.";
        this.EYDateTooltip = "Select the date when empty container was moved into depot.";
        this.portTooltip = "Select the port against which the stock will reflect.";
    }


    editContainer(containerObj) {
        this.clickedContainerObj = containerObj;
        this.openWarningDialog("Container Number", "This Container Number already exists", "Back", "View Details");
    }

    trimContainerNumber() {
        let container_no = this.containerObj.container_number.replace(/[-\s]/g, '');
        this.containerObj.container_number = container_no
    }

    isContainerNumberValid(label: string) {
        this.trimContainerNumber();
        this.getContainerValidity(label, this.containerObj.container_number);
    }

    openWarningDialog(label: string, temp, action1: string, action2?: string, action?: boolean) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            data: {
                subTitle: label,
                parent: this,
                description: temp,
                label1: action1,
                label2: action2,
                negativeAction: this.negativeResponse,
                positiveAction: this.positiveResponse
            }
        })
        dialogRef.afterClosed();
    }

    positiveResponse(parent) {
        parent.router.navigateByUrl(`/master-data/container-master?id=${parent.clickedContainerObj.id}`);
    }

    negativeResponse(parent) {
        parent.containerObj.container_number = null;
    }

    // Form display with respect to ownership detail
    displayForm(seq: any) {
        if (this.containerOwnershipList?.results[0].sequence_no == seq) {
            this.isShown = true;
            this.showProcurement = true;
            this.showLease = false;
            this.containerObj.lease_agreement = null;
            this.containerPurposeLabel = "Container Purpose*";
            this.containerEYLabel = "First EY at*";
            this.containerEYDateLabel = "First EY on*";
            this.company_url = `${ApiRoutes.Company}company/?name=::search::&is_internal=1`;
            if (!this.isEditable && this.containerObj.id) {
                if (this.containerObj.first_ey_date != null) {
                    this.EYDateTooltip = "This is the date when empty container was moved into depot.";
                } else {
                    this.EYDateTooltip = "Select the date when empty container was moved into depot.";
                }
                if (this.containerObj.first_ey_depot != null) {
                    this.EYTooltip = "This is the depot where first time the container was moved empty.";
                } else {
                    this.EYTooltip = "Select the depot where first time the container was moved empty.";
                }
                if (this.containerObj.current_location != null) {
                    this.portTooltip = "This is the port against which the stock will reflect.";
                } else {
                    this.portTooltip = "Select the port against which the stock will reflect.";
                }
            }
        } else if (this.containerOwnershipList?.results[1].sequence_no == seq) {
            this.isShown = true;
            this.showProcurement = false;
            this.showLease = true;
            if (!this.containerObj.id) {
                this.containerObj.lease_agreement = { ...this.defaultLeaseObject }
            }
            this.containerPurposeLabel = "Container Purpose*";
            this.containerEYLabel = "On-hire depot*";
            this.containerEYDateLabel = "On-hired on*";
            this.company_url = `${ApiRoutes.Company}company/?name=::search::&is_internal=0`;
            if (!this.isEditable && this.containerObj.id) {
                if (this.containerObj.first_ey_date != null) {
                    this.EYDateTooltip = "This is the date when container was on-hired on.";
                } else {
                    this.EYDateTooltip = "Select the date when container was on-hired on.";
                }
                if (this.containerObj.first_ey_depot != null) {
                    this.EYTooltip = "This is the depot where container was on-hired at.";
                } else {
                    this.EYTooltip = "Select the depot where container was on-hired at.";
                }
                if (this.containerObj.current_location != null) {
                    this.portTooltip = "This is the port against which the stock will reflect.";
                } else {
                    this.portTooltip = "Select the port against which the stock will reflect.";
                }
            }
        } else if (this.containerOwnershipList?.results[2].sequence_no == seq) {
            this.showProcurement = false;
            this.showLease = false;
            this.containerObj.lease_agreement = null;
            this.containerPurposeLabel = "Container Purpose"
            this.containerEYLabel = "EY at*"
            this.containerEYDateLabel = "EY date*"
            this.company_url = `${ApiRoutes.Company}company/?name=::search::&is_internal=0`;
            if (!this.isEditable && this.containerObj.id) {
                if (this.containerObj.first_ey_date != null) {
                    this.EYDateTooltip = "This is the date when empty container was moved into depot.";
                } else {
                    this.EYDateTooltip = "Select the date when empty container was moved into depot.";
                }
                if (this.containerObj.first_ey_depot != null) {
                    this.EYTooltip = "This is the depot where container was moved empty in.";
                } else {
                    this.EYTooltip = "Select the depot where container was moved empty in.";
                }
                if (this.containerObj.current_location != null) {
                    this.portTooltip = "This is the port against which the stock will reflect.";
                } else {
                    this.portTooltip = "Select the port against which the stock will reflect.";
                }
            }
        }
    }


    show() {
        // this.containerObj.insert_mode = CONTAINER_INSERT_MODE_SINGLE;
        this.single = true;
        this.bulk = false;
        this.clicked1();
        this.to(2);
    }

    hide() {
        // this.containerObj.insert_mode = CONTAINER_INSERT_MODE_BULK;
        this.bulk = true;
        this.single = false;
        this.clicked1();
        this.to(2)
        if (this.bulk) {
            this._snackBar.open("Feature is in development.", 'Close', {
                verticalPosition: 'top',
                duration: 5000,
            });
        }
    }

    backToList() {
        this.refreshContainer.emit();
        this.back.emit();
        this.router.navigate([], {
            queryParams: {
                'id': null,
            },
            queryParamsHandling: 'merge'
        });
        setTimeout(() => {
            // this.isEditable = true;
            this.containerObj = { ...this.defaultObj };
            this.containerSizeType = null;
            this.errorObj = {};

            this.loader = true;
        }, 600);
    }

    showpic() {
        this.pic = true;
    }

    bulkUpload() {
        document.getElementById("step2")!.innerHTML = "Bulk Upload";
        document.getElementById("i2")!.classList.replace('flaticon-characteristic', 'flaticon-bulkcontainer');
        document.getElementById("step3")!.innerHTML = "Completion";
        document.getElementById("i3")!.classList.replace('flaticon-paper', 'flaticon-accept');

        this.showPC = false;
        this.showBulk = true;
    }

    saveUpload() {
        this.showDoc = false;
        this.showCmplt = true;
    }

    to(a: any) {
        document.getElementById("card" + a)?.scrollIntoView({ block: "center", behavior: "smooth" });
        // this.scroller.scrollToAnchor("card4");
    }

    scrolltop() {
        document.getElementById("card1")?.scrollIntoView({ block: "center", behavior: "smooth" });
        // window.scrollTo(0,0);
    }

    scrolltop1() {
        document.getElementById("card4")?.scrollIntoView({ block: "center", behavior: "smooth" });
    }

    review() {
        document.getElementById("step3")!.innerHTML = "Completion";
        document.getElementById("i3")!.classList.replace('flaticon-paper', 'flaticon-accept');
        if (this.containerObj.id == null || this.containerObj.id == '') {
            this.showDoc = false;
            this.showReview = true;
        } else {
            this.showDoc = false;
            this.route.queryParams.subscribe(params => {
                if ('id' in params) {
                    this._snackBar.open("Container Details Updated!!", 'Close', {
                        duration: 3000,
                    });
                    setTimeout(() => {
                        this.router.navigateByUrl(`/dashboards/master-dashboard`);
                    }, 1200);
                } else {
                    this.complete();
                }
            });
        }
    }

    docs() {
        document.getElementById("step3")!.innerHTML = "Documents";
        document.getElementById("i3")!.classList.replace('flaticon-accept', 'flaticon-paper');
        this.showDoc = true;
        this.showReview = false;
    }

    complete() {
        this.showReview = false;
        this.showCmplt = true;
    }

    setContainerSizeType(containerSizeType) {
        this.containerSizeType = containerSizeType;
        this.containerObj.container_size = containerSizeType?.size;
        this.containerObj.container_type = containerSizeType?.type;
    }

    setContainerSizeTypeFromPO(event) {
        if (event != null) {
            this.containerSizeType = event;
            this.containerObj.container_size = event?.size;
            this.containerObj.container_type = event?.type;
            for (let i = 0; i < this.containerObj.purchase_order?.latest_quote?.quote_items?.length; i++) {
                if (event.id == this.containerObj.purchase_order?.latest_quote?.quote_items[i].container_size_type.id) {
                    if (this.containerObj.purchase_order?.latest_quote?.quote_items[i].price == null && this.containerObj.purchase_price == 0) {
                        this.containerObj.purchase_price = 0;
                    } else {
                        this.containerObj.purchase_price = this.containerObj.purchase_order?.latest_quote?.quote_items[i].price
                    }
                }
            }
        }
    }

    is_smart_device: boolean = false;

    containerOwnershipList: BackendListModel<DomainCode>; // Group by container ownership
    containerConditionList!: BackendListModel<DomainCode>; // Group by container condition
    containerPurposeList!: BackendListModel<DomainCode>; // Group by purpose of container deal
    containerProcurePortalList!: BackendListModel<DomainCode>; // Group by portal, container procured from

    getContainerGroup(grp = 'ContainerOwnership') {
        return this.domainService.getByGroup(grp).pipe(
            map(response => {
                this.containerOwnershipList = response;
                let data = [];
                for (let i = 0; i < response.results.length; i++) {
                    if (response.results[i].sequence_no >= 0) {
                        data.push(response.results[i])
                    }
                }
                this.containerOwnershipList.results = data;
            }),
            catchError(error => {
                console.log("ownership", error);
                return error;
            })
        );
    }

    getContainerCondition(grp = 'ContainerCondition') {
        return this.domainService.getByGroup(grp).pipe(
            map(response => {
                if (!response) {
                    console.log("Could not fetch");
                } else {
                    this.containerConditionList = response;
                }
            }),
            catchError(error => {
                console.log("condition", error);
                return error;
            })
        );
    }

    getContainerPurpose(grp = 'ContainerPurpose') {
        return this.domainService.getByGroup(grp).pipe(
            map(response => {
                if (!response) {
                    console.log("Could not fetch");
                } else {
                    this.containerPurposeList = response;
                }
            }),
            catchError(error => {
                console.log("purpose", error);
                return error;
            })
        );
    }

    getProcurementPortal(grp = 'ContainerProcuredFromPortal') {
        return this.domainService.getByGroup(grp).pipe(
            map(response => {
                if (!response) {
                    console.log("Could not fetch");
                } else {
                    this.containerProcurePortalList = response;
                }
            }),
            catchError(error => {
                console.log("procurement", error);
                return error;
            })
        );
    }

    getContainerValidity(label: string, container_number) {
        this.containerMasterService.checkContainerValidity(container_number).pipe(
            catchError(error => {
                console.log(error.status, error.statusText, error.error)
                this.openWarningDialog(`${label} is invalid`, error.error.error.message, "");
                this.errorObj = { container_number: [error.error.error.message] }
                return error;
            })
        ).subscribe(response => {
            return response
        })
    }

    catchError(error) {
        let stepIndex: number;
        if (error.status >= 500) {
            this.errorObj = { ...error.error };
            stepIndex = this.jumpToStepOnError(this.errorObj)
            this.selectCDKIndex(stepIndex);
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = { ...error.error };
            stepIndex = this.jumpToStepOnError(this.errorObj)
            this.selectCDKIndex(stepIndex);
            return error;
        }
    }

    postContainerInformation(data) {
        if (data.default_photo == null && data.photos != null) {
            data.default_photo = data.photos[0];
        }
        this.containerMasterService.postContainerData(data).subscribe({
            next: response => {
                console.log("post vala response", response)
                this.complete();
                this.isEditable = false;
                return response;
            },
            error: error => {
                this.isEditable = true;
                this.docs();
                return this.catchError(error);
            }
        });
    }


    updateContainerInformation(data) {
        if (data.default_photo != null) {
            if (typeof data.default_photo == 'object') {
                data.default_photo = data.default_photo.id;
            }
        }
        this.containerMasterService.updateContainerData(data).subscribe({
            next: response => {
                console.log("update vala response", response)
                this.isEditable = false;
                return response;
            },
            error: error => {
                this.isEditable = true;
                return this.catchError(error);
            }
        });
    }

    // Post Container Data
    postContainer() {
        let payload = this.filterContainerData();

        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                console.log(payload, params);
                this.updateContainerInformation(payload);
            } else {
                console.log(payload, params);
                this.postContainerInformation(payload);
            }
        });
    }

    getSelectedOwnershipItem() {
        if (this.containerObj.ownership) {
            let ownershipId = this.containerObj.ownership['id'];
            if (this.containerOwnershipList) {
                let filtered = this.containerOwnershipList.results.filter(item => item.id == ownershipId)
                if (filtered.length !== 1) {
                    console.error("GRAVEERROR!!!!!");
                }
                return filtered[0];
            }
            return null;
        }
    }

    onOwnershipChange() {
        let selectedItem = this.getSelectedOwnershipItem();
        if (selectedItem) {
            this.displayForm(selectedItem.sequence_no);
            this.clicked();
        }
    }


    getContainerInfoById(id) {
        this.containerMasterService.getContainerDataById(id).subscribe({
            next: response => {
                this.containerObj = { ...response }
                console.log("containerObj after", this.containerObj)

                if (this.containerObj.lease_agreement == null) {
                    this.containerObj.lease_agreement = { ...this.defaultLeaseObject };
                }
                if (this.containerObj['lifecycle'] != null) {
                    this.containerLifecycleStatus = this.containerObj['lifecycle'].name;
                    this.containerActivityDate = this.containerObj['lifecycle'].updated_at;
                }
                this.is_smart_device = this.smartDevice();
                if (this.is_smart_device) {
                    this.clicked()
                }
                if (this.containerObj.default_photo != null) {
                    this.projectPhoto = this.containerObj.default_photo.document_file;
                }
                this.show();
                setTimeout(() => {
                    this.loader = false;
                }, 800);
                this.setContainerSizeType(response.container_size_type);
                this.displayForm(this.containerObj.ownership['sequence_no']);
            },
            error: error => {
                if (error.status >= 500) {
                    this._snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                        verticalPosition: 'top',
                        duration: 5000,
                    });
                    return error;
                } else {
                    console.log("get container by id", error.error);
                    return error;
                }
            }
        });
    }

    getContainerBookingDetails(id) {
        this.containerMasterService.getBookingDetails(id).subscribe({
            next: res => {
                this.bookingDetails = res;
            },
            error: err => {
                console.log(err);
            }
        })
    }

    getContainerGradeByManufacturingDate(data) {
        this.containerMasterService.getContainerGrade(data).subscribe({
            next: response => {
                this.containerGrade = true;
                this.containerGradeObj = response
            },
            error: error => {
                console.log(error);
                return error;
            }
        });
    }

    checkContainerGrade(event) {
        if (event != null) {
            let month = new Date(event).getMonth()
            let year = new Date(event).getFullYear()
            let monthYearObj = { month: month + 1, year: year };
            this.getContainerGradeByManufacturingDate(monthYearObj)
        } else {
            this.containerGrade = false;
            this.containerGradeObj = null;
        }
    }

    leaseType;

    getLease(event) {
        if (event != null) {
            this.isLeaseEditable = false;
            this.containerObj.lease_agreement = event;
        }
    }

    // Smart Device slide toggle functionality w.r.t Edit & View mode
    smartDevice() {
        if (this.containerObj.device_name != null || this.containerObj.device_id != null) {
            return true;
        } else {
            return false;
        }
    }

    // For pushing IDs into the form for posting data to server
    keysToTransform = [
        'ownership',
        'condition',
        'purpose',
        'procured_from',
        'stock_owner',
        'current_location',
        'first_ey_depot',
        'lease',
        'default_photo',
        'lease_agreement',
        'purchase_order',
        'domesticated_at'
    ];


    // Filtering Data (bind ids to form instead objects)
    filterContainerData() {
        let data = { ...this.containerObj }

        for (const key of this.keysToTransform) {
            if (data[key] != null && data[key] != undefined) {
                data[key] = data[key].id;
            }
        }

        data.photos = this.getIdListFromObjList(data.photos);
        data.documents = this.getIdListFromObjList(data.documents);
        data.created_by = null;
        data.updated_by = null;

        if (this.is_smart_device == false) {
            data.device_name = null;
            data.device_id = null
        }

        return data;
    }

    // Filtering id list from object list
    getIdListFromObjList(objList: any[]) {
        let objIds = []
        for (let obj of objList) {
            objIds.push(obj.id);
        }
        return objIds;
    }

    //For Quick Add Depot on Container
    bindName = new BehaviorSubject(null);

    openDepotSidePanel(data) {
        this.open = " sidepanel slidepanelOpen";
        this.Canvas = " Canvas setCanvas";
        setTimeout(() => {
            this.bindName.next(data);
        }, 500);
    }

    closeDepotSidePanel() {
        this.selectedDepot = { ...this.defaultDepot };
        this.open = " sidepanel";
        this.Canvas = " Canvas ";
        this.bindName.next(null);

    }

    closeDepotForm() {
        this.selectedDepot = { ...this.defaultDepot };
        this.containerObj.first_ey_depot = this.defaultObj.first_ey_depot;
        this.errorObj = {};
        this.open = " sidepanel";
        this.Canvas = " Canvas ";
    }

    selectDepotForm(depot) {
        if (depot != null) {
            if (depot.id != null) {
                this.containerObj.first_ey_depot = depot;
            } else {
                this.openDepotSidePanel(depot.name_display)
            }
        }

    }

    bindDepot(event) {
        if (event != null) {
            this.getDepotByID(event.id)

        }
    }

    //get Depot name
    @Input()
    depotBindToForm = new Subject()

    getDepotbyName() {
        this.depotBindToForm.subscribe(item => {
            if (item != null && item != undefined) {
                if (this.containerObj.first_ey_depot['id'] != item['id']) {
                    this.getDepotByID(item['id']);
                }
            } else {
                this.containerObj.first_ey_depot = null;
            }
        })
    }

    //get Depot By ID
    getDepotByID(id) {
        this.depotMasterService.getDepotMasterbyID(id).subscribe({
            next: response => {
                this.containerObj.first_ey_depot = JSON.parse(JSON.stringify(response));
                return response;
            }
        });
    }


    projectPhoto: string;
    isDefault: boolean = false;

    project(a: string, b: string) {
        this.projectPhoto = a;
        if (b = "default") {
            this.isDefault = true;
        } else {
            this.isDefault = false;
        }
    }

    goToList() {
        this.router.navigate(['master-data/container-master']).then(() => {
            window.location.reload();
        });
    }

    goToAddNewContainer() {
        // this.goToList();
        this.router.navigate([], {
            queryParams: {
                'id': null,
            },
            queryParamsHandling: 'merge'
        });
        setTimeout(() => {
            this.addNew.emit();
            this.resetComponent();
            this.docs();
            this.selectCDKIndex(0);
        }, 20);
        this.containerSizeType = null;
    }


    onPONumberSelect(event) {
        if (event != null) {
            this.containerObj.purchase_order = event;
            if (event.latest_quote != null) {
                this.sizeTypeListFromPurchaseOrder = []
                for (let i = 0; i < event.latest_quote.quote_items.length; i++) {
                    this.sizeTypeListFromPurchaseOrder.push(event.latest_quote.quote_items[i].container_size_type)
                }
            } else {
                this.sizeTypeListFromPurchaseOrder = [];
            }
            if (event.requestor != null && event.requestor.company != null) {
                this.containerObj.vendor_name = event.requestor.company.legal_name;
            }
        } else {
            this.sizeTypeListFromPurchaseOrder = [];
            this.containerObj.vendor_name = null
        }
    }

    redirectToRequest(request) {
        window.open(`/requests/request-processing/request-details?id=${request?.id}&type=${request?.transaction_type}&rtype=${request?.request_type?.dev_name}`, '_blank');
    }

    getLifeCycleCount(event: number) {
        this.lifeCycleCount = event;
    }

    disableCurrentLocation() {
        return this.lifeCycleCount != null && this.lifeCycleCount > 1;
    }

    openDialogue(purpose: any) {
        const dialogRef = this.dialog.open(RequestorDialogComponent, {
            panelClass: 'dialog-container-custom',
            data: purpose
        })
        dialogRef.afterClosed();
    }

    onPurposeChange(purpose: any) {
        if (purpose == 'domestication') {
            this.containerObj.assessment_value = null;
            this.containerObj.assessment_value_currency = 'USD';
            this.containerObj.domesticated_at = null;
            this.containerObj.cha_agency_name = null;
            this.containerObj.custom_duty_charge = null;
            this.containerObj.custom_duty_charge_currency = 'USD';
            this.containerObj.domestication_remarks = null;
        } else {

        }
    }
}

type AOA = any[][];
